import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { Amplify } from 'aws-amplify';
import awsExports from './aws-exports';

// If you have the buffer shim, keep it ABOVE any code:
import { Buffer } from 'buffer';

// ---- SIMPLE, DIRECT CONFIG ----
Amplify.configure(awsExports);
// -------------------------------

if (!window.Buffer) window.Buffer = Buffer;

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();

